import { useCan } from "@/auth/member";
import { ExperienceBandsPanel } from "@/components/experience-bands-panel";
import { JDPoliciesPanel } from "@/components/jd-policies-panel";
import { JDSettingsPanel } from "@/components/jd-settings-panel";
import { PrimarySharePanel } from "@/components/primary-share-panel";
import { Callout } from "@/components/ui/panel";

/**
 * Config — settings an admin tunes live, with no deploy (DESIGN §17.5, §20.4): how hard the
 * Question Picker asks at each experience level, and how job descriptions are read and weighed. `POST /pick` reads the saved table on every call,
 * so a change here is what the Interviewer gets on its next request. The Picker page is only a
 * console for testing that API and holds no settings.
 */
export default function Config() {
  const canManage = useCan("manage_picker");

  return (
    <div className="flex flex-col gap-3 p-4">
      <h1 className="text-base font-semibold tracking-tight">Config</h1>
      {canManage ? (
        <>
          <ExperienceBandsPanel />
          <PrimarySharePanel />
          <JDSettingsPanel />
          <JDPoliciesPanel />
        </>
      ) : (
        <Callout>Only admins change these settings.</Callout>
      )}
    </div>
  );
}
